<div id="kt_content" class="kt-content  kt-grid__item kt-grid__item--fluid">
  <div class="kt-portlet kt-portlet--mobile">
    <div class="kt-portlet__body">
      <!-- Filter -->
      <div class="kt-form kt-form--label-right">
        <div class="row align-items-center">
          <div class="col-xl-12 order-2 order-xl-1 pr-0">
            <form class="row align-items-center" [formGroup]="form">
              <div class="col-12 row pr-0 mb-2">
                <div class="col-md-1 kt-form__label col-form-label">
                  <label>Username:</label>
                </div>
                <div class="col-md-2 kt-form__control">
                  <input type="text" formControlName="username" placeholder="Search" class="form-control"
                    (input)="toLowerCaseInput('username', $event)"/>
                </div>
                <div class="col-md-1 kt-form__label col-form-label">
                  <label>Activity ID:</label>
                </div>
                <div class="col-md-2 kt-form__control">
                  <input type="text" formControlName="activity_id" placeholder="Search" class="form-control"/>
                </div>
                <div class="col-md-1 kt-form__label col-form-label">
                  <label>Promotion:</label>
                </div>
                <div class="col-md-4 kt-form__control">
                  <input type="text" class="form-control" placeholder="Search"
                    formControlName="promotion"
                    [ngbTypeahead]="searchPromo"
                    [resultFormatter]="formatPromo"
                    [inputFormatter]="formatPromo"
                    (selectItem)="onPromoSelected($event.item)" />
                </div>
              </div>
              <div class="col-12 row pr-0 mb-2">
                <div class="col-md-1 kt-form__label col-form-label">
                  <label>Date/Time:</label>
                </div>
                <div class="col-md-5 kt-form__control">
                  <div class="input-group date">
                    <input type="text" class="form-control" placeholder="Search"
                      [formControl]="form.controls['defaultDate']"
                      (change)="onDateRange($event)"
                      (click)="updateDateRange()"
                      [timePicker]="true" [timePickerSeconds]="true"
                      [alwaysShowCalendars]="true" [ranges]="ranges" [maxDate]="maxDate"
                      [showCustomRangeLabel]="true" [locale]="dateTimePickerLocale"
                      [timePicker24Hour]="true" [opens]="'left'" [showDropdowns]="true"
                      ngxDaterangepickerMd/>
                    <span class="input-group-append">
                      <span class="input-group-text pointer-calendar" (click)="onClearDate()">X</span>
                    </span>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <!-- Filter Action -->
      <div class="kt-section col-12 row mb-3 mt-3">
          <div class="dropdown dropdown-inline">
            <kt-search-button [loading]="searchBtnLoading" [disabledButton]="loading" (search)="onSubmit()"></kt-search-button>
            <kt-clear-button [loading]="clearBtnLoading" [disabledButton]="loading" (clear)="onClear()"></kt-clear-button>
          </div>
      </div>
      <!-- Table -->
      <div class="kt-section">
        <div class="kt-section__content">
          <div class="table-responsive">
            <table class="table table-bordered table-hover table-striped table-sortable">
              <thead>
                <tr>
                  <th class="col-1 text-left sort-enabled" (click)="onSortColumn('id')" [ngClass]="sortingConfig.id" [class.sort-selected]="sortingSelection.sort_by === 'id'">ID</th>
                  <th class="text-left sort-enabled" (click)="onSortColumn('username')" [ngClass]="sortingConfig.username" [class.sort-selected]="sortingSelection.sort_by === 'username'">Username</th>
                  <th class="text-center sort-enabled" (click)="onSortColumn('activity_id')" [ngClass]="sortingConfig.activity_id" [class.sort-selected]="sortingSelection.sort_by === 'activity_id'">Activity ID</th>
                  <th class="text-center">Reward</th>
                  <th class="text-center">Message</th>
                  <th class="text-center">SMS</th>
                  <th class="text-center sort-enabled" (click)="onSortColumn('created_at')" [ngClass]="sortingConfig.created_at" [class.sort-selected]="sortingSelection.sort_by === 'created_at'">Created At</th>
                  <th class="text-center sort-enabled" (click)="onSortColumn('updated_at')" [ngClass]="sortingConfig.updated_at" [class.sort-selected]="sortingSelection.sort_by === 'updated_at'">Updated At</th>
                  <th class="text-center">Action</th>
                </tr>
              </thead>  
              <tbody *ngIf="(logs$ | async) as rows">
                <tr *ngFor="let row of rows">
                  <td>{{ row.id }}</td>
                  <td>
                    <a class="font-weight-bold" (click)="showMember(row.member_account_id)">{{ row.username }}</a>
                  </td>
                  <td class="text-center text-break mw-100">{{ row.activity_id }}</td>
                  <td class="text-center">
                    <span *ngIf="row.reward_id">
                      <div><b>{{ row.promotion_name }}</b></div>
                      <div *ngIf="row.reward_credit">{{ row.currency_code }} {{ row.reward_credit | number:'1.2-2' }}</div>
                      <div>
                        <span *ngIf="row.reward_status">{{ row.reward_status }}</span>
                        <span *ngIf="row.reward_status == 'Claimed' || row.reward_status == 'Expired' || row.reward_status == 'Cancelled'">
                          on
                          <span [ngSwitch]="row.reward_status">
                            <ng-container *ngSwitchCase="'Claimed'">
                              {{ row.reward_claimed_at | timezoneDate: 'YYYY-MM-DD HH:mm' }}
                            </ng-container>
                            <ng-container *ngSwitchCase="'Expired'">
                              {{ row.reward_expiry_datetime | timezoneDate: 'YYYY-MM-DD HH:mm' }}
                            </ng-container>
                            <ng-container *ngSwitchDefault>
                              {{ row.reward_updated_at | timezoneDate: 'YYYY-MM-DD HH:mm' }}
                            </ng-container>
                          </span>
                        </span>
                      </div>
                    </span>
                  </td>
                  <td class="text-center">
                    <div *ngIf="row.message_content || row.message_id">
                      <div *ngIf="row.message_title"><b>{{ row.message_title }}</b></div>
                      <div *ngIf="row.message_content">
                        <div [innerHTML]="getShortContent(row.message_content, 80)"></div>
                        <div *ngIf="row.message_content.length > 80">
                          <a class="text-primary pointer" (click)="showContentModal(row.message_title || 'Message', row.message_content)">Read more</a>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td class="text-center">
                    <div *ngIf="row.sms_content || row.sms_log_id">
                      <div *ngIf="row.sms_subject"><b>{{ row.sms_subject }}</b></div>
                      <div *ngIf="row.sms_content">
                        <div [innerHTML]="getShortContent(row.sms_content, 80)"></div>
                        <div *ngIf="row.sms_content.length > 80">
                          <a class="text-primary pointer" (click)="showContentModal(row.sms_subject || 'SMS', row.sms_content)">Read more</a>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td class="text-center">{{ row.created_at | timezoneDate: 'YYYY-MM-DD HH:mm' }}</td>
                  <td class="text-center">{{ row.updated_at | timezoneDate: 'YYYY-MM-DD HH:mm' }}</td>
                  <td class="text-center">
                    <button 
                      *ngIf="canAccessLinkedReward && row.reward_id > 0"
                      matTooltip="Link To Reward"
                      class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"
                      (click)="linkReward(row.username, row.promotion_code)">
                      <i class="fa fa-gift"></i>
                    </button>
                    <button
                      *ngIf="canAccessLinkedMemberMessage && row.message_id > 0"
                      matTooltip="Link To Message"
                      class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"
                      (click)="linkMessage(row.username)">
                      <i class="fa fa-envelope"></i>
                    </button>
                    <button
                      *ngIf="canAccessLinkedMemberSms && row.sms_log_id > 0"
                      matTooltip="Link To SMS"
                      class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"
                      (click)="linkSms(row.username)">
                      <i class="fa fa-sms"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
              <tbody shared-table-handler [loading]="loading" [dataLength]="dataLength" class="text-gray-600 fw-bold"></tbody>
            </table>
          </div>
          <div class="kt-pagination kt-pagination--brand mt-2" *ngIf="pagination !== undefined">
            <ngb-pagination
              [pageSize]="pageSize"
              [(page)]="page"
              [maxSize]="maxSize"
              [directionLinks]="true"
              [boundaryLinks]="true"
              [rotate]="true"
              [collectionSize]="pagination.total"
              (pageChange)="onViewPageBy(page)">
            </ngb-pagination>
            <div class="kt-pagination__toolbar">
              <select (change)="onPerPage($event)" [(ngModel)]="pageSize" class="form-control kt-font-brand page-size">
                <option [value]="item" *ngFor="let item of dropdown.perPage">{{ item }}</option>
              </select>
              <span class="pagination__desc">
                Showing {{pagination.from}} to {{pagination.to}} of {{ pagination.total | number : '1.0' }} records
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- message for permission error -->
<kt-swal-alert [message]="messages2$ | async" [icon]="'error'"></kt-swal-alert>
<kt-swal-alert [message]="messages$ | async"></kt-swal-alert>